import {pageInfo, initPage, initUpdate,exportData,initOrderNo,initMivDate,downtemplate,importOrder,updateOrder,rePush, rePushBatch} from './../api';
import {selectCarrier, selectDelayResonCode,mdBrandList} from '../../../../api'
import { Message } from 'element-ui';
const tracking = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    initPageObj: null,
    initUpdateObj: null,
    exportObj:null,
    orderNoObj:null,
    mivInfoObj:null,
    carrierObj:null,
    delayResonCodeObj:null,
    templateObj:null,
    importOrderObj:null,
    brandObj:null,
    updateOrderObj:null,
    rePushObj: null,
    rePushBatchObj: null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    ORDER_NO(state,data){
      state.orderNoObj = (data.obj || []).map((item, index) => {
        console.log(item.bdOrderLogisticsVOS,'===BdOrderLogisticsVOS');
        return {
          ...item,
          lable: item.planArriveTime +  '【' + item.orderNo +'】',
          bdOrderLogisticsVOS: item.bdOrderLogisticsVOS.map((subItem, subIndex)=>{

            if(subIndex==0) {
              return {
                ...subItem,
                color: '#26654D'
              }
            }
            return subItem;
          })
        }
      });
    },
    MIV_DATE(state,data){
      state.mivInfoObj = data.obj || []
    },
    SELECT_CARRIER(state, resp){
      state.carrierObj = resp.obj || [];
    },
    SELECT_BRAND(state, resp){
      state.brandObj = resp.obj || [];
    },
    SELECT_DELAYRESONCODE(state, resp){
      state.delayResonCodeObj = resp.obj || [];
    },
    IMPORT_ORDER(state, data){
      state. importOrderObj = data;
    },
    UPDATE_ORDER(state, data){
      state. updateOrderObj = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    REPUSH(state,data){
      state.rePushObj = data;
    },
    REPUSHBATCH(state,data){
      state.rePushBatchObj = data;
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //品牌
    async mdBrandList({ commit }, obj) {
      let resp = await mdBrandList(obj);
      commit('SELECT_BRAND', resp);
    },
    //物流商
    async ListCarrierSelect({ commit }, obj) {
      let resp = await selectCarrier(obj);
      commit('SELECT_CARRIER', resp);
    },
    //延迟原因
    async ListDelayResonCodeSelect({ commit }, obj) {
      let resp = await selectDelayResonCode(obj);
      commit('SELECT_DELAYRESONCODE', resp);
    },
    async initOrderNo({commit}, obj){
      let resp = await initOrderNo(obj);
      commit('ORDER_NO', resp);
    },
    async initMivDate({commit}, obj){
      let resp = await initMivDate(obj);
      commit('MIV_DATE', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //导入特殊订单
    async importOrder({ commit }, obj) {
      let resp = await importOrder(obj);
      commit('IMPORT_ORDER', resp);
    },
    //导入订单修改
    async updateOrder({ commit }, obj) {
      let resp = await updateOrder(obj);
      commit('UPDATE_ORDER', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //rePush
    async rePush({ commit }, obj) {
      let resp = await rePush(obj);
      commit('REPUSH', resp);
    },
    //rePushBatch
    async rePushBatch({ commit }, obj) {
      let resp = await rePushBatch(obj);
      commit('REPUSHBATCH', resp);
    },
  }
}
export default tracking



// WEBPACK FOOTER //
// ./src/page/toBTracking/tracking/store/tracking.store.js